import { useGo } from '../../app/navigation';
import { type PreparedSong, SONGS } from '../../content/songs';
import { useProgress } from '../../core/store';
import { Icon } from '../../ui/icons';
import { Rich } from '../../ui/Rich';
import { GroupTitle } from '../module/ModulePage';
import { loadSongState } from './state';

export const LEVEL_NAME: Record<number, string> = { 1: 'Kolay', 2: 'Orta', 3: 'Zor' };

function SongCard({ s }: { s: PreparedSong }) {
  const go = useGo();
  const st = loadSongState(s.id);
  const solvedN = st.ok.length;
  return (
    <button type="button" className="song-card" data-song={s.id} onClick={() => go(`akor.sarki.${s.id}`)}>
      <div className="sg-meta">
        <span className={`sg-tag lv${s.level}`}>{LEVEL_NAME[s.level]}</span>
        {s.cover ? <span className="sg-tag">{s.cover.artist}</span> : null}
        <span className="sg-tag">{s.style}</span>
        <span className="sg-tag">
          {s.beats}/4 · {s.bpm} BPM
        </span>
      </div>
      <h3>{s.title}</h3>
      <p>
        <Rich text={s.desc} inert />
      </p>
      <div className="sg-status">
        {st.solved ? <Icon name="check" /> : null}
        {st.solved
          ? `Çözüldü${st.best ? ` · birlikte çalma: %${st.best}` : ''}`
          : solvedN
            ? `${solvedN}/${s.bars.length} ölçü bulundu`
            : `${s.bars.length} ölçü · ${new Set(s.bars.map((b) => b.chord)).size} farklı akor`}
      </div>
    </button>
  );
}

export function SongList() {
  const go = useGo();
  useProgress();
  const originals = SONGS.filter((s) => !s.cover);
  const covers = SONGS.filter((s) => s.cover);
  return (
    <>
      <GroupTitle
        title="Şarkılar"
        sub="Bu bölüm için yazılmış özgün şarkılar. Önce her ölçünün akorunu kulaktan bul, sonra mikrofonla baştan sona birlikte çal."
      />
      <button type="button" className="jam-link" onClick={() => go('jam')}>
        <Icon name="jam" />
        <span>
          <b>Jam'de çal</b> Bu şarkıları oyun gibi de çalabilirsin: akorlar aksın, doğru çaldıkça puanın katlansın.
        </span>
        <Icon name="right" />
      </button>
      <div className="song-list">
        {originals.map((s) => (
          <SongCard key={s.id} s={s} />
        ))}
      </div>
      {covers.length ? (
        <>
          <GroupTitle
            title="Sevilen şarkılar"
            sub="Tanıdık şarkıların akorları. Sözler ve melodi burada yok: kaydı dinleyerek akorları kulaktan bul, sonra birlikte çal."
          />
          <div className="song-list">
            {covers.map((s) => (
              <SongCard key={s.id} s={s} />
            ))}
          </div>
        </>
      ) : null}
    </>
  );
}
